import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import { MyPromise } from '../interceptors/myPromise.service';

const URL = `${environment.baseEndpoint}/outsideStaff`;

@Injectable({
  providedIn: 'root',
})
export class OutsideStaffService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise,
  ) { }

  index(stationId: string) {
    return this.myPromise.to(this.http.get(`${URL}/station/${stationId}`));
  }

  create(stationId: string, data: object) {
    return this.myPromise.to(this.http.post(`${URL}/station/${stationId}`, data));
  }

  update(stationId: string, id: string, data: object) {
    return this.myPromise.to(this.http.put(`${URL}/station/${stationId}/outside-staff/${id}`, data));
  }

  delete(stationId: string, id: string) {
    return this.myPromise.to(this.http.delete(`${URL}/station/${stationId}/outside-staff/${id}`));
  }
}
